import styled from 'styled-components';
import { fadeIn } from '../layout/keyframes';
import { theme } from '../layout/theme';

export const DropdownListContainer = styled.div`
  position: absolute;
  z-index: ${theme.layers.panel};
  transform-origin: top;
  overflow-y: auto;
  box-shadow: 1px 3px 8px 0px rgb(146, 146, 146);
  border: 1px solid rgb(223, 223, 223);
  border-radius: 8px;
  margin-top: 12px;
  max-height: 480px;
  background: #ffffff;
  ${theme.screens.LtMd} {
    position: fixed;
    max-height: 100%;
    left: 0;
    bottom: 0;
    width: 100%;
    overflow: auto;
    box-shadow: 0 0 0 rgb(0 0 0 / 15%);
  }
  ${theme.screens.SmLtMd} {
    transform: translateY(12%);
  }
`;

export const Overlay = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: ${theme.layers.belowPanel};
  background: transparent;
  animation: ${fadeIn} 125ms linear;
  ${theme.screens.LtMd} {
    background: rgba(0, 0, 0, 0.1);
  }

  ${theme.screens.Md} {
    display: none;
  }
`;
